import { useResourceObserver } from './resourceObserver';
import { initial, normalizeResourceOptions, skipped } from './shared';
export function watch(resource, options) {
  return Object.assign({
    resource: resource
  }, normalizeResourceOptions(options));
}
export const useResources = descriptors => useResourceObserver(descriptors, (ctrl, {
  resource,
  params,
  instanceKey,
  skip
}) => {
  var _ctrl$getState;
  return skip ? skipped : (_ctrl$getState = ctrl.getState({
    resource,
    params,
    instanceKey
  })) !== null && _ctrl$getState !== void 0 ? _ctrl$getState : initial;
});